import React, { useContext } from "react";

import { TextFit } from "@/common/TextFit";
import { PollProps } from "@/containers/Poll/PollContainer";
import PollOption from "@/containers/Poll/templates/bildTvApp/PollOption";
import { getPollOptionVotesPercent, PollContext } from "@/contexts";
import { Option, PollResult, PollVote } from "@/service/Model";

import {
  FadeInText,
  Header,
  OptionsWrapper,
  ThankYou,
  Title,
  TotalVotes,
  Wrapper,
} from "./styles";

const BildTvAppPoll: React.FC<PollProps> = (
  props: PollProps
): React.JSX.Element => {
  const { interaction, interactionResults, votes, expired } = props;
  const { slides } = interaction;

  const pollContext = useContext(PollContext);

  const voted = votes.length > 0;
  const slideId = slides.length ? slides[0].id : "";
  const options = slides.length ? slides[0].options : [];

  const slideUserVotes: PollVote[] = votes.filter(
    (vote: PollVote) => slideId === vote.slideId
  );
  const slideResults: PollResult[] = interactionResults.results.filter(
    (pollResult: PollResult) => pollResult.slideId === slideId
  );

  const totalVotes = slideResults
    .map((result: PollResult) => result.value)
    .reduce((a: number, b: number): number => a + b, 0);

  const getPercent = (optionId: string) => {
    const isUserAnswer = !!slideUserVotes.find(
      (vote: PollVote) => vote.optionId === optionId
    );

    return voted
      ? getPollOptionVotesPercent(slideResults, optionId, true, isUserAnswer)
      : 0;
  };

  const getVotes = (optionId: string) => {
    const optionResult = slideResults.find(
      (pollResult: PollResult) => pollResult.optionId === optionId
    );

    const isUserAnswer = !!slideUserVotes.find(
      (vote: PollVote) => vote.optionId === optionId
    );

    let count = optionResult ? optionResult.value : 0;
    if (isUserAnswer) {
      count++;
    }
    return count;
  };

  return (
    <Wrapper>
      <Header>
        <Title>
          <TextFit maxHeight={180} maxFontSize={40} text={interaction.title} />
        </Title>
        <TotalVotes>{`${totalVotes.toLocaleString()} Stimmen`}</TotalVotes>
      </Header>
      <OptionsWrapper>
        {options.map((option: Option) => (
          <PollOption
            key={`option-${option.id}`}
            text={option.content}
            percent={getPercent(option.id)}
            votes={getVotes(option.id)}
            voted={voted}
            onClick={() => {
              if (expired || voted) {
                return;
              }
              pollContext.onVote({
                interactionId: interaction.id,
                optionId: option.id,
                slideId: slideId,
              });
            }}
          />
        ))}
      </OptionsWrapper>
      <ThankYou>
        {voted && (
          <FadeInText $delay={800}>
            {"Danke! BILD - deine Stimme zählt!"}
          </FadeInText>
        )}
      </ThankYou>
    </Wrapper>
  );
};

export default BildTvAppPoll;
